var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"chart-data":_vm.chartData,"label-callback":_vm.chartLabelCallback,"before-label-callback":_vm.chartBeforeLabelCallback,"after-label-callback":_vm.chartAfterLabelCallback,"tooltip-mode":"nearest"}})}
var staticRenderFns = []

export { render, staticRenderFns }